export const AIDKIT_STREAMING_AUTH_HEADER = 'X-AidKit-Authorization';

async function sha256Hex(value: string): Promise<string> {
  const bytes = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
}

/**
 * CloudFront OAC requires an explicit payload hash for POST requests to Lambda
 * Function URL origins. Hash the exact serialized body produced by the AI SDK.
 */
export async function fetchWithAwsPayloadHash(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (typeof init?.body !== 'string') {
    throw new Error('Streaming requests require a serialized JSON body');
  }

  const headers = new Headers(init.headers);
  headers.set('X-Amz-Content-Sha256', await sha256Hex(init.body));
  return fetch(input, { ...init, headers });
}
